module.exports = __webpack_public_path__ + "assets/media/purple-arrow-2.8990800f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookDemoRequestStep/purple-arrow-2.svg
// module id = 3148
// module chunks = 0